<template>
  <div class="h-full relative">
    <Panorama />
    <Header class="fixed top-0 z-10" />
    <Transition name="fade">
      <RouterView class="z-10" />
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Panorama from '@/components/Panorama.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'Explore',

  components: {
    Panorama,
    Header
  },

  computed: {
    ...mapGetters([ 'post' ])
  }
}
</script>
